










import settings from '@/settings'
import LoginPart from "@/core/login_part"
import LostPasswordPart from "@/core/lost_password_part"

export default {
    name: 'login'

    components: {
        LoginPart, LostPasswordPart
    }

    data: ()->
        part: 'login'
        email: ''
        unusable: false

    methods:
        lost_password: (email, unusable)->
            @email = email
            @part = 'lost'
            @unusable = unusable
            # console.log "lost pw ", @email
            return

        cancel: ()->
            @email = ''
            @unusable = false
            @part = 'login'
            return

    mounted: ()->
        @part = 'login'
        # console.log "LOGIN PART : "+@part
}

